export enum AssessmentScaleGroup {
  Fixed = 1,
  Variable = 2
}
export enum AssessmentScaleMethod {
  Pecentage = 1,
  ActualPoint = 2
}
